// extracted by mini-css-extract-plugin
export default {"ingredients":"burger-ingredients_ingredients__SC2nC"};